import Backdrop from '@material-ui/core/Backdrop'
import Paper from '@material-ui/core/Paper'
import MenuButton from './MenuButton'

import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import Division from './Division'
import imgDesktop from '../../../../assets/images/story-desktop.jpg'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backgroundColor: theme.palette.primary.main,
    padding: 0,
    overflow: 'scroll',
    display: 'block',
    zIndex: 50,
  },
  close: {
    position: 'absolute',
    top: 0,
    right: 1,
    width: 180,
    height: 120,
    textAlign: 'right',
    zIndex: 100,
    background:
      'linear-gradient( to left bottom, rgba(0, 0, 0, 1) 7%, rgba(0, 0, 0, 0.7) 15%, rgba(0, 0, 0, 0) 55%)',
  },
  signup: {
    marginTop: 10,
  },
  container: {
    display: 'flex',
    minHeight: '100%',
    alignItems: 'center',
  },
  gridContainer: {
    minHeight: '100%',
    margin: '100px 0',
  },
  gridItem: {
    padding: '16px 24px',
  },
  paper: (props) => ({
    margin: '16px 0px',
    padding: isWidthUp('md', props.width) ? '32px 80px 64px 80px' : '24px 24px 48px 24px',
  }),
  image: {
    width: '100%',
    paddingBottom: 24,
    paddingTop: 8,
  },
  button: (props) => ({
    paddingLeft: isWidthUp('md', props.width) ? 50 : 'inherit',
    paddingRight: isWidthUp('md', props.width) ? 50 : 'inherit',
  }),
}))

const Story = ({ onClose, story, show, width, onClick }) => {
  const classes = useStyles({ width })

  const hasName = !!story?.signup?.first_name
  const person = !!story?.signup?.first_name ? `${story?.signup?.first_name}'s` : 'this'

  return (
    <Backdrop open={show} classes={{ root: classes.backdrop }}>
      <div className={classes.close}>
        <MenuButton onClick={onClose} action="close" />
      </div>
      <Container disableGutters className={classes.container}>
        <Grid
          container
          direction="column"
          className={classes.gridContainer}
          alignItems={isWidthUp('md', width) ? 'center' : 'stretch'}
        >
          <Grid item xs={12} sm={10} md={9} lg={8}>
            <Paper square elevation={0} className={classes.paper}>
              <Typography variant="h4" align="center">
                {hasName ? story?.signup?.first_name + "'s " : 'Their '}Story
              </Typography>
              <Division padding={16} />
              <img src={imgDesktop} alt="generic story image" className={classes.image} />
              <Typography variant="body1">{story?.story}</Typography>
            </Paper>
          </Grid>
          <Grid item className={classes.gridItem}>
            <Typography
              variant="h5"
              style={{ color: 'white' }}
              align="center"
            >{`Want to make sure ${
              hasName ? story?.signup?.first_name + "'s" : 'their'
            } story doesn't happen again?`}</Typography>
          </Grid>
          <Grid item className={classes.gridItem}>
            <Button
              variant="contained"
              color="secondary"
              onClick={onClick}
              fullWidth
              classes={{ root: classes.button }}
            >
              TAKE ACTION NOW
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Backdrop>
  )
}

export default withWidth()(Story)
